export const propertyTestimonials = ['$scope', function($scope) {
  $scope.mobile = true 
  $scope.checkMobile = () => {
    $scope.mobile = window.matchMedia('(max-width: 700px)').matches
    return window.matchMedia('(max-width: 700px)').matches
  }
}]
